export const TEXT = ["id", "description", "value"];
//export const ASSIGNMENT = ['id', 'name'];
